<div class="d-flex flex-column justify-content-between service-card" [style.backgroundImage]="'url(' + background + ')'">
  <h3 class="text-uppercase">{{ title }}</h3>
  <div style="overflow: hidden">
    <p>{{ text }}</p>
  </div>
  <img src="{{ iconBefore }}" class="service-icon-before">
  <img src="{{ iconAfter }}" class="service-icon-after">
</div>